module.exports = __webpack_public_path__ + "img/result.27650059.png";